/**
 * Support and updates expiry date: Wed Dec 07 2022
 * @external https://mui.com/components/data-grid/getting-started/#license-key-installation
 */
import { LicenseInfo } from '@mui/x-data-grid-pro'
import config from './appConfig'

LicenseInfo.setLicenseKey(config.muiLicenseKey)
